


































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";

import Logs from "./log.vue";

@Component({
  components: {
    Logs,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  logsModalVisible = false;

  itemsoption: any[] = [];

  dispatchType = "projects/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    // { title: '所属客户', dataIndex: 'customer' },
    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "申请人用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "申请时间", dataIndex: "created_time" },
    { title: "进度", scopedSlots: { customRender: "step" } },
    { title: "状态", scopedSlots: { customRender: "item_name" } },
    { title: "是否当前", scopedSlots: { customRender: "is_current" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.checkPermission("");

    this.loadItemsOption();

    // console.log('在获取权限之后')
    this.loadData();
  }

  async loadItemsOption() {
    const res = await this.$store.dispatch("projects/itemsoption", {});
    if (res && res.Data && res.Data !== "{}") {
      this.itemsoption = res.Data;
    }
  }

  showLogsModal(id: number) {
    this.editId = id;
    this.logsModalVisible = true;
  }

  hideLogsModal() {
    this.logsModalVisible = false;
  }
}
